<template>
  <v-app>
    <div class="wrapper">
      <v-flex v-if="checkCabecalho()">
        <Header :key="`hdr-${menuVersion}`" />
      </v-flex>
      <div :class="{ 'main-panel': checkCabecalho() }">
      <PageBarraAviso
      ref="barraAviso"
       v-if="checkCabecalho() && showAviso && Avisos"
      @close="fecharAviso"
      :titulo="Avisos.admTitulo"
      :mensagem="Avisos.admTexto"
      :textoBotao="Avisos.admTextoBotao"
      :linkBotao="Avisos.admLinkBotao"
    />
        <Topo v-if="checkCabecalho()" :key="`topo-${menuVersion}`" />

        <router-view :key="$route.fullPath" :style="checkCabecalho() ? { 'margin-top': '80px' } : {}" />
        <FooterPage v-if="checkCabecalho()" style="padding-top: 100px;" />
      </div>
    </div>
  </v-app>
</template>

<script>
import axios from 'axios';
import Header from './components/PageHeader.vue'
import FooterPage from './components/PageFooter.vue'
import Loader from './components/PageLoader.vue'
import Topo from './components/PageTopo.vue'
import PageBarraAviso from './components/PageBarraAviso.vue'

export default {
  name: 'App',
  components: {
    Header,
    FooterPage,
    Loader,
    Topo,
    PageBarraAviso
  },
data: () => ({
  drawer: true,
  rail: true,
  sidebarClosed: false,
  menuVersion: 0,
  showAviso: false,
  Avisos: null
}),

async mounted() {
  window.addEventListener('menu:updated', this.onMenuUpdated)

  if (this.checkCabecalho()) {
    await this.carregarAviso()
  }
},

watch: {
  async $route() {
    if (this.$route.meta.hideHeader) {
      this.showAviso = false
      return
    }

    await this.carregarAviso()
  }
},

methods: {
  checkCabecalho() {
    return !this.$route.meta.hideHeader
  },

  onMenuUpdated() {
    this.menuVersion++
  },

  fecharAviso() {
    this.showAviso = false
    sessionStorage.setItem('avisoSistemaFechado', '1')
  },

async carregarAviso() {
  if (sessionStorage.getItem('avisoSistemaFechado') === '1') {
    this.Avisos = null
    this.showAviso = false
    return
  }

  try {
    const response = await axios.get(`/Telas/CadastroAvisoSistema/GetAvisoExibicao`, { skipAuthRedirect: true })

    this.Avisos = response.data
    this.showAviso = !!this.Avisos
  } catch (error) {
    this.Avisos = null
    this.showAviso = false
  }
}
},
  async created() {

  },
}
</script>
<style>
@import "@/assets/css/bootstrap.min.css";
@import "@/assets/css/plugins.min.css";
@import "@/assets/css/kaiadmin.min.css";


@media (max-width:767px) {
  .hidden-xs {
    display: none !important;
  }
}

@media (min-width:768px) and (max-width:991px) {
  .hidden-sm {
    display: none !important;
  }
}

@media (min-width:992px) and (max-width:1199px) {
  .hidden-md {
    display: none !important;
  }
}

@media (min-width:1200px) {
  .hidden-lg {
    display: none !important;
  }
}


.main-container {
  width: 100%;
  flex: 1;
  overflow-y: auto;
}

.v-label {
  align-items: center;
  display: inline-flex;
  font-size: 14px !important;
  letter-spacing: 0.009375em;
  min-width: 0;
  opacity: var(--v-medium-emphasis-opacity);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ckeditor */
.ck.ck-editor__editable_inline {
  border: 1px solid #cccccc !important;
  min-height: 100px;
}

/* ckeditor */


/* customiza datatables */
.editiconcor {
  color: #0033CC;
}

.deliconcor {
  color: red;
}

.customize-table {
  --easy-table-border: 1px solid #cccccc;
  --easy-table-row-border: 1px solid #cccccc;

  --easy-table-header-font-size: 14px;
  --easy-table-header-height: 30px;
  --easy-table-header-font-color: #fff;
  --easy-table-header-background-color: #1a2035;

  --easy-table-header-item-padding: 10px 5px;

  --easy-table-body-even-row-font-color: #000;
  --easy-table-body-even-row-background-color: #ecf0f4;

  --easy-table-body-row-font-color: #000000;
  /*--easy-table-body-row-background-color: #2d3a4f;
  --easy-table-body-row-height: 50px;
  --easy-table-body-row-font-size: 14px;

  --easy-table-body-row-hover-font-color: #2d3a4f;
  --easy-table-body-row-hover-background-color: #eee;

  --easy-table-body-item-padding: 10px 15px;

  --easy-table-footer-background-color: #2d3a4f;
  --easy-table-footer-font-color: #c0c7d2;
  --easy-table-footer-font-size: 14px;
  --easy-table-footer-padding: 0px 10px;
  --easy-table-footer-height: 50px;

  --easy-table-rows-per-page-selector-width: 70px;
  --easy-table-rows-per-page-selector-option-padding: 10px;
  --easy-table-rows-per-page-selector-z-index: 1;


  --easy-table-scrollbar-track-color: #2d3a4f;
  --easy-table-scrollbar-color: #2d3a4f;
  --easy-table-scrollbar-thumb-color: #4c5d7a;;
  --easy-table-scrollbar-corner-color: #2d3a4f;

  --easy-table-loading-mask-background-color: #2d3a4f;
  
   <!--
   <template #item-player="{ player, avator, page }">
      <div class="player-wrapper">
        <img class="avator" :src="avator" alt="" />
        <a target="_blank" :href="page">{{ player }}</a>
      </div>
    </template>
    <template #item-team="{ teamName, teamUrl }">
      <a target="_blank" :href="teamUrl">{{ teamName }}</a>
    </template>
    <template #item-operation="item">
      <div class="operation-wrapper">
          <img
          src="./images/delete.png"
          class="operation-icon"
          @click="deleteItem(item)"
          />
          <img
          src="./images/edit.png"
          class="operation-icon"
          @click="editItem(item)"
          />
      </div>
      </template>

                  /*{ text: "Id", value: "grtId",fixed: true, width: 40 }, -- congela coluna*/
  /*{ text: "Id", value: "grtId",sortable: true, width: 200 }, -- ordenação coluna

                     // formattedDate (value) {
        //    return this.$moment(value).format('DD/MM/YYYY')
        // }

        //import moment from 'moment'
    -->
  
  */
}

/* customiza datatables */

.v-application {
  display: flex;
  background: transparent !important;
}

.swal2-container {
  z-index: 999999 !important;
  /* Defina um valor de z-index alto o suficiente */
}
</style>
